import React from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';

import MenuItem from '@material-ui/core/MenuItem';

import { userSelector } from '../reducers/current-user-selectors';

import { clearLegacyTokens, getLegacyTokens } from '../authentication/get-legacy-tokens';
import { accountBaseRoute, LOGGED_OUT_ROUTE } from '../web-routes';

import { DOMAIN } from '../config/config';
import { HelpScout } from '../util/helpscout-beacon';

type InputProps = {
  onClose: () => void;
};

export const OrganizationDropdownActions = (props: InputProps) => {
  const { onClose } = props;
  const user = useSelector(userSelector);
  const history = useHistory();
  const { search, pathname } = useLocation();

  const goToAccount = () => {
    onClose();
    history.push(accountBaseRoute(), {
      previousLocationPath: search ? `${pathname}${search}` : pathname,
    });
  };

  const openDocs = () => {
    onClose();
    HelpScout.beacon.navigate('/answers/');
  };

  const openPrivacyPolicy = () => {
    onClose();
    window.open('https://www.teamengine.io/privacy-policy', '_blank');
  };

  const { logout, isAuthenticated } = useAuth0();
  const legacyTokens = getLegacyTokens();
  const canLogOut = isAuthenticated || legacyTokens;
  const logOut = () => {
    onClose();
    clearLegacyTokens();
    const loggedOutUrl = `${DOMAIN}${LOGGED_OUT_ROUTE}`;
    if (isAuthenticated) {
      logout({
        returnTo: loggedOutUrl,
      });
    } else {
      window.location.replace(loggedOutUrl);
    }
  };

  return (
    <>
      {user?.username && (
        <MenuItem className="u-no-padding-u" onClick={goToAccount}>
          Account
        </MenuItem>
      )}
      <MenuItem className="u-no-padding-u" onClick={openDocs}>
        Help
      </MenuItem>
      <MenuItem className="u-no-padding-u" onClick={openPrivacyPolicy}>
        Privacy Policy
      </MenuItem>
      {canLogOut ? (
        <MenuItem className="u-no-padding-u" onClick={logOut}>
          Log Out
        </MenuItem>
      ) : null}
    </>
  );
};
